import cn from 'classnames';
import React, { useCallback } from 'react';

import SteppedModal, { SteppedModalProps } from 'components/SteppedModal';
import { block } from './utils';

export interface TikTokPostModalProps
  extends Pick<
    SteppedModalProps,
    | 'title'
    | 'show'
    | 'defaultStep'
    | 'steps'
    | 'onStepChange'
    | 'onHide'
    | 'onExited'
  > {
  className?: string;
  onHide?: () => void;
}

const TikTokPostModal = React.forwardRef<SteppedModal, TikTokPostModalProps>(
  (
    {
      title,
      show,
      defaultStep,
      steps,
      className,
      onStepChange,
      onHide,
      onExited,
    },
    ref,
  ) => {
    const handleHide = useCallback(() => {
      onHide?.();
    }, [onHide]);

    return (
      <SteppedModal
        {...{
          ref,
          title,
          show,
          defaultStep,
          steps,
          onStepChange,
          onExited,
        }}
        baseClassName={cn(block(), className)}
        onHide={handleHide}
      />
    );
  },
);

export default TikTokPostModal;
